import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Text, Title, Button, Drawer, Divider } from "@mantine/core";
import React, { useEffect, useState } from "react";
import {
    Table,
    Tag,
    Row,
    Col,
    DatePicker,
    Select,
    Input,
    Space,
    Card, Descriptions, message
} from "antd";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import { Get_Payout_History, Get_Verify_History } from "../../../apicall";
import dayjs from "dayjs";


const Retailertrxnreports = ({ Headername }) => {
    const columns = [
        {
            title: "Date & Time",
            key: "createdAt",
            width: 160,
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 600 }}>
                        {dayjs(record?.createdAt).format(
                            "DD MMM YYYY"
                        )}
                    </div>

                    <div
                        style={{
                            fontSize: 12,
                            color: "#888",
                        }}
                    >
                        {dayjs(record?.createdAt).format(
                            "hh:mm A"
                        )}
                    </div>
                </div>
            ),
        },

        {
            title: "Service",
            key: "serviceType",
            width: 170,
            render: (_, record) =>
                renderServiceType(record),
        },

        {
            title: "Transaction",
            key: "transaction",
            width: 240,
            render: (_, record) => (
                <div>
                    <div
                        style={{
                            fontWeight: 600,
                            wordBreak: "break-all",
                        }}
                    >
                        {record?.transactionID}
                    </div>

                    {record?.utr && (
                        <div
                            style={{
                                fontSize: 12,
                                color: "#888",
                                marginTop: 3,
                            }}
                        >
                            UTR: {record.utr}
                        </div>
                    )}
                </div>
            ),
        },

        {
            title: "Customer / Beneficiary",
            key: "beneficiary",
            width: 230,
            render: (_, record) => (
                <div>
                    <div
                        style={{
                            fontWeight: 600,
                        }}
                    >
                        {record?.beneficiaryName ||
                            "N/A"}
                    </div>

                    <div
                        style={{
                            fontSize: 12,
                            color: "#777",
                            marginTop: 3,
                        }}
                    >
                        A/C:{" "}
                        {record?.accountNumber ||
                            "N/A"}
                    </div>

                    <div
                        style={{
                            fontSize: 12,
                            color: "#777",
                        }}
                    >
                        IFSC:{" "}
                        {record?.ifsc || "N/A"}
                    </div>
                </div>
            ),
        },

        {
            title: "Amount",
            key: "amount",
            width: 120,
            align: "right",
            render: (_, record) => {
                if (
                    record?.serviceType ===
                    "Bank_Verification"
                ) {
                    return (
                        <span
                            style={{
                                color: "#999",
                            }}
                        >
                            —
                        </span>
                    );
                }

                return (
                    <span
                        style={{
                            fontWeight: 600,
                        }}
                    >
                        ₹{" "}
                        {Number(
                            record?.amount || 0
                        ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                        })}
                    </span>
                );
            },
        },

        {
            title: "Status",
            key: "status",
            width: 120,
            render: (_, record) =>
                renderTransactionStatus(record),
        },

        {
            title: "Action",
            key: "action",
            width: 100,
            fixed: "right",
            align: "center",
            render: (_, record) => (
                <Button
                    size="xs"
                    variant="outline"
                    onClick={() => {
                        setSelectedTransaction(record);
                        setDetailsDrawerOpen(true);
                    }}
                >
                    Details
                </Button>
            ),
        },
    ];
    const { user } = Userauthcontexthooks();
    const today = dayjs();
    const [dateRange, setDateRange] = useState([
        today.startOf("day"),
        today.endOf("day"),
    ]);

    const [serviceType, setServiceType] = useState("all");
    const [status, setStatus] = useState("all");
    const [searchTxn, setSearchTxn] = useState("");
    const [appliedSearch, setAppliedSearch] = useState("");

    const [allPayouthistories, setAllpayouthistories] = useState([]);
    const [allVerifyhistories, setAllverifyhistories] = useState([]);

    const [filteredTransactions, setFilteredTransactions] = useState([]);

    const [transactionLoading, setTransactionLoading] = useState(true);

    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [detailsDrawerOpen, setDetailsDrawerOpen] = useState(false);

    const normalizeTransactions = () => {
        const payoutTransactions = allPayouthistories.map((item) => {
            const request = item?.requestPayload || {};
            const response = item?.responsePayload || {};

            return {
                ...item,

                serviceType: "Payment_Transfer",

                displayService: "Payment Transfer",

                transactionID:
                    item?.requestID || "N/A",

                utr:
                    response?.utr || "",

                transactionStatus:
                    (
                        response?.reqStatus ||
                        item?.providerStatus ||
                        ""
                    ).toUpperCase(),

                beneficiaryName:
                    request?.custName || "N/A",

                accountNumber:
                    request?.custAccountNumber || "",

                ifsc:
                    request?.custIFSC || "",

                amount:
                    Number(request?.transferAmount || 0),

                transactionType:
                    request?.transferType || "IMPS",
            };
        });

        const verificationTransactions =
            allVerifyhistories.map((item) => {
                const request = item?.requestPayload || {};
                const response = item?.responsePayload || {};

                return {
                    ...item,

                    serviceType: "Bank_Verification",

                    displayService: "Bank Verification",

                    transactionID:
                        item?.requestID || "N/A",

                    utr:
                        response?.utr || "",

                    transactionStatus:
                        (
                            response?.reqStatus ||
                            response?.accountValidationStatus ||
                            ""
                        ).toUpperCase(),

                    beneficiaryName:
                        response?.beneName || "N/A",

                    accountNumber:
                        response?.beneAccountNumber ||
                        request?.custAccountNumber ||
                        "",

                    ifsc:
                        response?.beneIFSC ||
                        request?.custIFSC ||
                        "",

                    amount: null,

                    transactionType:
                        request?.verificationType ||
                        "Account Verification",
                };
            });

        return [
            ...payoutTransactions,
            ...verificationTransactions,
        ];
    };
    const renderTransactionStatus = (record) => {
        const currentStatus =
            record?.transactionStatus?.toUpperCase();

        switch (currentStatus) {
            case "SUCCESS":
            case "SUCCESSFUL":
            case "COMPLETED":
            case "ACCOUNT_VALID":
                return (
                    <Tag color="green">
                        SUCCESS
                    </Tag>
                );

            case "PENDING":
                return (
                    <Tag color="orange">
                        PENDING
                    </Tag>
                );

            case "FAILED":
            case "FAILURE":
            case "REJECTED":
                return (
                    <Tag color="red">
                        FAILED
                    </Tag>
                );

            case "REFUND":
            case "REFUNDED":
                return (
                    <Tag color="blue">
                        REFUNDED
                    </Tag>
                );

            default:
                return (
                    <Tag>
                        {currentStatus || "UNKNOWN"}
                    </Tag>
                );
        }
    };
    const renderServiceType = (record) => {
        if (
            record?.serviceType ===
            "Payment_Transfer"
        ) {
            return (
                <Tag color="blue">
                    Payment Transfer
                </Tag>
            );
        }

        if (
            record?.serviceType ===
            "Bank_Verification"
        ) {
            return (
                <Tag color="purple">
                    Bank Verification
                </Tag>
            );
        }

        return <Tag>Unknown</Tag>;
    };
    const handleSearch = () => {
        setAppliedSearch(searchTxn);
    };
    const handleReset = () => {
        setServiceType("all");
        setStatus("all");
        setSearchTxn("");
        setAppliedSearch("");
        setDateRange([
            today.startOf("day"),
            today.endOf("day"),
        ])
    };

    const fetchpayouthistory = async () => {
        try {
            const data = await Get_Payout_History(
                dateRange[0].format("YYYY-MM-DD"),
                dateRange[1].format("YYYY-MM-DD")
            )
            //console.log("payout histories:", data);

            if (data.success) {
                setAllpayouthistories(data?.payoutRequests);
                //setfilteredpayouthistories(data?.payoutRequests);
            }

        } catch (error) {
            message.error(error.response?.data?.message || "Something went wrong.");
        } finally {
            setTransactionLoading(false);
        }
    }
    const fetchverificationhistory = async () => {
        try {
            const data = await Get_Verify_History(
                dateRange[0].format("YYYY-MM-DD"),
                dateRange[1].format("YYYY-MM-DD")
            )
            //console.log("verify histories:", data);

            if (data.success) {
                setAllverifyhistories(data?.verificationRequests);
                //setfilteredverifyhistories(data?.verificationRequests);
            }

        } catch (error) {
            message.error(error.response?.data?.message || "Something went wrong.");
        } finally {
            setTransactionLoading(false);
        }
    }

    const fetchTransactionReports = async () => {
        try {
            setTransactionLoading(true);

            await Promise.all([
                fetchpayouthistory(),
                fetchverificationhistory(),
            ]);
        } catch (error) {
            console.error(error);
        } finally {
            setTransactionLoading(false);
        }
    };

    useEffect(() => {

        const fetchpayouthistory = async () => {
            try {
                const data = await Get_Payout_History(
                    dateRange[0].format("YYYY-MM-DD"),
                    dateRange[1].format("YYYY-MM-DD")
                )
                //console.log("payout histories:", data);

                if (data.success) {
                    setAllpayouthistories(data?.payoutRequests);
                    //setfilteredpayouthistories(data?.payoutRequests);
                }

            } catch (error) {
                message.error(error.response?.data?.message || "Something went wrong.");
            }
        }

        const fetchverificationhistory = async () => {
            try {
                const data = await Get_Verify_History(
                    dateRange[0].format("YYYY-MM-DD"),
                    dateRange[1].format("YYYY-MM-DD")
                )
                //console.log("verify histories:", data);

                if (data.success) {
                    setAllverifyhistories(data?.verificationRequests);
                    //setfilteredverifyhistories(data?.verificationRequests);
                }

            } catch (error) {
                message.error(error.response?.data?.message || "Something went wrong.");
            }
        }

        const fetchTransactionReports = async () => {
            try {
                setTransactionLoading(true);

                await Promise.all([
                    fetchpayouthistory(),
                    fetchverificationhistory(),
                ]);
            } catch (error) {
                console.error(error);
            } finally {
                setTransactionLoading(false);
            }
        };

        if (user) {
            fetchTransactionReports()
        }
    }, [user, dateRange])

    useEffect(() => {
        const transactions = normalizeTransactions();

        let filtered = [...transactions];

        // SERVICE TYPE
        if (serviceType !== "all") {
            filtered = filtered.filter(
                (item) =>
                    item.serviceType === serviceType
            );
        }

        // STATUS
        if (status !== "all") {
            filtered = filtered.filter((item) => {
                const currentStatus =
                    item.transactionStatus?.toLowerCase();

                if (status === "refund") {
                    return (
                        item?.refundCompleted === true ||
                        currentStatus === "refunded" ||
                        currentStatus === "refund"
                    );
                }

                return currentStatus === status;
            });
        }

        // SEARCH
        const search = appliedSearch
            .trim()
            .toLowerCase();

        if (search) {
            filtered = filtered.filter((item) => {
                return (
                    item?.transactionID
                        ?.toLowerCase()
                        .includes(search) ||

                    item?.responseID
                        ?.toLowerCase()
                        .includes(search) ||

                    item?.providerTransactionID
                        ?.toLowerCase()
                        .includes(search) ||

                    item?.providerClientTransactionID
                        ?.toLowerCase()
                        .includes(search) ||

                    item?.utr
                        ?.toLowerCase()
                        .includes(search) ||

                    item?.accountNumber
                        ?.toLowerCase()
                        .includes(search) ||

                    item?.beneficiaryName
                        ?.toLowerCase()
                        .includes(search)
                );
            });
        }

        // Latest first
        filtered.sort(
            (a, b) =>
                new Date(b.createdAt) -
                new Date(a.createdAt)
        );

        setFilteredTransactions(filtered);

    }, [
        allPayouthistories,
        allVerifyhistories,
        serviceType,
        status,
        appliedSearch,
    ]);
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Transaction Reports</Title>
                <Text size="xs">Verify your transaction in transaction reports</Text>
            </Container>

            <Container size={'lg'} mt={'lg'}>
                <Card
                    title="Transaction History"
                    style={{
                        width: "100%",
                    }}
                >
                    <Row
                        gutter={[16, 16]}
                        style={{
                            marginBottom: 20,
                        }}
                    >
                        <Col xs={24} md={7}>
                            <DatePicker.RangePicker
                                style={{
                                    width: "100%",
                                }}
                                value={dateRange}
                                onChange={(value) => {
                                    if (value) {
                                        setDateRange(value);
                                    }
                                }}
                                allowClear={false}
                            />
                        </Col>

                        <Col xs={24} md={4}>
                            <Select
                                value={serviceType}
                                onChange={setServiceType}
                                style={{
                                    width: "100%",
                                }}
                                options={[
                                    {
                                        label: "All Services",
                                        value: "all",
                                    },
                                    {
                                        label: "Payment Transfer",
                                        value: "Payment_Transfer",
                                    },
                                    {
                                        label: "Bank Verification",
                                        value: "Bank_Verification",
                                    },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={4}>
                            <Select
                                value={status}
                                onChange={setStatus}
                                style={{
                                    width: "100%",
                                }}
                                options={[
                                    {
                                        label: "All Status",
                                        value: "all",
                                    },
                                    {
                                        label: "Success",
                                        value: "success",
                                    },
                                    {
                                        label: "Failed",
                                        value: "failed",
                                    },
                                    {
                                        label: "Pending",
                                        value: "pending",
                                    },
                                    {
                                        label: "Refunded",
                                        value: "refund",
                                    },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={5}>
                            <Input.Search
                                placeholder="Search ID / UTR / Account"
                                allowClear
                                value={searchTxn}
                                onChange={(e) =>
                                    setSearchTxn(e.target.value)
                                }
                                onSearch={handleSearch}
                            />
                        </Col>
                    </Row>

                    <Col
                        style={{
                            marginBottom: 16,
                        }}
                    >
                        <Space wrap>
                            <Button
                                type="primary"
                                onClick={handleSearch}
                            >
                                Search
                            </Button>

                            <Button onClick={handleReset} variant="light">
                                Reset
                            </Button>

                            <Button variant="outline">
                                Download
                            </Button>

                            <Button onClick={fetchTransactionReports} variant="outline">
                                Refresh
                            </Button>
                        </Space>
                    </Col>

                    <div
                        style={{
                            width: "100%",
                            overflowX: "auto",
                        }}
                    >
                        <Table
                            columns={columns}
                            dataSource={filteredTransactions}
                            loading={transactionLoading}
                            bordered
                            size="middle"
                            rowKey="_id"

                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                                showTotal: (total) =>
                                    `Total ${total} transactions`,
                            }}
                        />
                    </div>
                </Card>
            </Container>

            <Drawer
                title={
                    selectedTransaction?.serviceType ===
                        "Bank_Verification"
                        ? "Bank Verification Details"
                        : "Payment Transfer Details"
                }
                placement="right"
                width={600}
                opened={detailsDrawerOpen}
                onClose={() => {
                    setDetailsDrawerOpen(false);
                    setSelectedTransaction(null);
                }}
            >
                {selectedTransaction && (
                    <>
                        <Descriptions
                            title="Transaction Information"
                            bordered
                            column={1}
                            size="small"
                            style={{ padding: '10px' }}
                        >
                            <Descriptions.Item label="Service">
                                {selectedTransaction?.displayService}
                            </Descriptions.Item>

                            <Descriptions.Item label="Request ID">
                                {selectedTransaction?.requestID ||
                                    "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Response ID">
                                {selectedTransaction?.responseID ||
                                    "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Status">
                                {renderTransactionStatus(
                                    selectedTransaction
                                )}
                            </Descriptions.Item>

                            <Descriptions.Item label="Date & Time">
                                {selectedTransaction?.createdAt
                                    ? dayjs(
                                        selectedTransaction.createdAt
                                    ).format(
                                        "DD MMM YYYY, hh:mm:ss A"
                                    )
                                    : "N/A"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Beneficiary Details"
                            bordered
                            column={1}
                            size="small"
                            style={{ padding: '10px' }}
                        >
                            <Descriptions.Item label="Name">
                                {selectedTransaction?.beneficiaryName ||
                                    "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Account Number">
                                {selectedTransaction?.accountNumber ||
                                    "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="IFSC">
                                {selectedTransaction?.ifsc ||
                                    "N/A"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        {selectedTransaction?.serviceType ===
                            "Payment_Transfer" ? (
                            <Descriptions
                                title="Payment Details"
                                bordered
                                column={1}
                                size="small"
                                style={{ padding: '10px' }}
                            >
                                <Descriptions.Item label="Amount">
                                    ₹{" "}
                                    {Number(
                                        selectedTransaction?.amount ||
                                        0
                                    ).toLocaleString(
                                        "en-IN",
                                        {
                                            minimumFractionDigits: 2,
                                        }
                                    )}
                                </Descriptions.Item>

                                <Descriptions.Item label="Transfer Type">
                                    {selectedTransaction
                                        ?.requestPayload
                                        ?.transferType ||
                                        "N/A"}
                                </Descriptions.Item>

                                <Descriptions.Item label="Mobile">
                                    {selectedTransaction
                                        ?.requestPayload
                                        ?.custMobileNumber ||
                                        "N/A"}
                                </Descriptions.Item>

                                <Descriptions.Item label="UTR">
                                    {selectedTransaction?.utr ||
                                        "N/A"}
                                </Descriptions.Item>
                            </Descriptions>
                        ) : (
                            <Descriptions
                                title="Verification Details"
                                bordered
                                column={1}
                                size="small"
                                style={{ padding: '10px' }}
                            >
                                <Descriptions.Item label="Verification Type">
                                    {selectedTransaction
                                        ?.requestPayload
                                        ?.verificationType ||
                                        "N/A"}
                                </Descriptions.Item>

                                <Descriptions.Item label="Account Validation">
                                    {selectedTransaction
                                        ?.responsePayload
                                        ?.accountValidationStatus ||
                                        "N/A"}
                                </Descriptions.Item>

                                <Descriptions.Item label="UTR">
                                    {selectedTransaction
                                        ?.responsePayload
                                        ?.utr || "N/A"}
                                </Descriptions.Item>

                                <Descriptions.Item label="Status Code">
                                    {selectedTransaction
                                        ?.responsePayload
                                        ?.statusCode ?? "N/A"}
                                </Descriptions.Item>
                            </Descriptions>
                        )}

                        <Divider />

                        <Descriptions
                            title="Technical Information"
                            bordered
                            column={1}
                            size="small"
                            style={{ padding: '10px' }}
                        >

                            <Descriptions.Item label="Created At">
                                {selectedTransaction?.createdAt
                                    ? dayjs(
                                        selectedTransaction.createdAt
                                    ).format(
                                        "DD MMM YYYY HH:mm:ss"
                                    )
                                    : "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Updated At">
                                {selectedTransaction?.updatedAt
                                    ? dayjs(
                                        selectedTransaction.updatedAt
                                    ).format(
                                        "DD MMM YYYY HH:mm:ss"
                                    )
                                    : "N/A"}
                            </Descriptions.Item>
                        </Descriptions>
                    </>
                )}
            </Drawer>
        </>
    )
}
export default Retailertrxnreports;